import { ASSET_HISTORY_CRUD_ACTION_CONSTANTS as CRUD_ACTION_CONSTANTS } from '../actions/asset_history_actions';
import { standardInitialStateGenerator, standardReducerGenerator } from './standard_reducer_utils';

const initialState: any = standardInitialStateGenerator(['assetHistoryIndex']);
export default standardReducerGenerator(CRUD_ACTION_CONSTANTS, initialState);
